// @file Helper for prerendering a page before the user visits it
import { asciiSafeStringify } from '@@/bits/json_stringify'
import { prefetch } from '@@/bits/prefetch'

const prerenderedUrls = new Set<string>()

// We add the speculationrules to the document head if the browser supports it
export function appendSpeculationRules(url: string): void {
  const script = document.createElement('script')
  script.type = 'speculationrules'
  script.textContent = asciiSafeStringify({
    prerender: [
      {
        source: 'list',
        urls: [url],
      },
    ],
  })
  document.head.append(script)
}

export function prerender(url: string): void {
  if (prerenderedUrls.has(url)) return
  if (HTMLScriptElement.supports?.('speculationrules')) {
    appendSpeculationRules(url)
  }
  // We add prefetch as a fallback.
  // https://developer.mozilla.org/en-US/docs/Web/API/Speculation_Rules_API#using_prefetching
  prefetch(url)
  prerenderedUrls.add(url)
}
